module.exports = require("@mui/icons-material/ContentPasteGo");